import { useHandleEscapeKey } from 'hooks'
import { Box } from 'theme-ui'

export const BasicConfirmationModal = ({
  header,
  body,
  handleCancel,
}: {
  header: string | JSX.Element
  body?: string | JSX.Element
  handleCancel: () => void
}) => {
  useHandleEscapeKey(handleCancel)
  return (
    <Box>
      {typeof header === 'string' ? (
        <Box variant="text.h2" sx={{ pb: 20 }}>
          {header}
        </Box>
      ) : (
        header
      )}
      {typeof body === 'string' ? (
        <Box variant="text.secondary" sx={{ maxWidth: [278, 'unset'] }}>
          {body}
        </Box>
      ) : (
        body
      )}
    </Box>
  )
}
